export interface IWorkOrderList {
  data: IWorkOrder[];
  errors: null;
  pageNumber: number;
  totalItemCount: number;
}

export interface IWorkOrderInitials {
  statusId: string;
  typeId: string;
  organizationGroupId: string;
  responsibleUserId: string;
  isLocked: boolean;
  title: string;
  description: string;
  priorityId: number | null;
  customerId: string;
  isNotifyTheCustomer: boolean;
  creatorId: string;
  productTypeId: string;
  urgencyId: number | null;
  relatedGroups: any[];
  relation: string;
  relations: {
    relatedWorkOrderId: string;
    relationTypeId: number;
  }[];
  operators: {
    operatorId: string;
  }[];
  workOrderConfigurationGroupId: string;
  workOrderConfigurationItems: string;
  detail: {
    categoryId: string;
    rootReasonId: string;
    serviceName: string;
    additionalInfo: string;
    actionFieldId: number | null;
    solutionExplanation: string;
    closureTypeId: number | null;
    closureTypeDescription: string;
    proposalId: string;
    activityId: string;
    isDataBank: boolean;
    changeTypeId: number | string;
    downTimeId: number | string;
    changeStartDate: Date;
    actualChangeStartDate: Date | string;
    changeEndDate: Date;
    actualChangeEndDate: Date | string;
    returnManagement: string;
    possibleEffectsAndRisk: string;
    controlInstructions: string;
    importanceLevelId: number | string;
    customerAddressId: string;
  };
  documents: IDocuments[];
  // documents: [
  // {
  // documentCategoryId: string;
  // description: string;
  // startDate: string;
  // endDate: string;
  // isESignatured: boolean;
  // isEDocument: boolean;
  // documentId: string;
  // }
  // ];
}

export interface IWorkOrder extends IWorkOrderInitials {
  id: string;
}

export interface IDocuments {
  documentCategoryId: string;
  description: string;
  file: {
    base64: string;
    fileName: string;
    contentType: string;
  };
}

export const workOrderInitials: IWorkOrderInitials = {
  statusId: "",
  typeId: "",
  organizationGroupId: "",
  responsibleUserId: "",
  isLocked: false,
  title: "",
  description: "",
  priorityId: 1,
  urgencyId: 1,
  customerId: "",
  isNotifyTheCustomer: false,
  relatedGroups: [],
  relation: "",
  relations: [],
  workOrderConfigurationGroupId: "",
  workOrderConfigurationItems: "",
  operators: [],
  creatorId: "",
  productTypeId: "",
  detail: {
    categoryId: "",
    rootReasonId: "",
    serviceName: "",
    additionalInfo: "",
    actionFieldId: null,
    solutionExplanation: "",
    closureTypeId: null,
    closureTypeDescription: "",
    proposalId: "",
    activityId: "",
    isDataBank: false,
    changeTypeId: "",
    downTimeId: "",
    changeStartDate: new Date(),
    changeEndDate: new Date(new Date().getTime() + 15 * 60000),
    actualChangeStartDate: "",
    actualChangeEndDate: "",
    returnManagement: "",
    possibleEffectsAndRisk: "",
    controlInstructions: "",
    importanceLevelId: "",
    customerAddressId: "",
  },
  documents: [
    {
      documentCategoryId: "",
      description: "",
      file: {
        base64: "",
        fileName: "",
        contentType: "",
      },
    },
  ],
};

export interface IWorkOrderDocumentInitials {
  description: string;
  documentCategoryId: string;
  file: {
    base64: string;
    fileName: string;
    contentType: string;
  };
  creatorId: string;
}

export const workOrderDocumentInitials: IWorkOrderDocumentInitials = {
  description: "",
  documentCategoryId: "",
  file: {
    base64: "",
    fileName: "",
    contentType: "",
  },
  creatorId: "",
};

export const workOrderFilterInitials = {
  workOrderNumber: "",
  customerIds: "",
  organizationGroupIds: "",
  parentOrganizationGroupId: "",
  responsibleUserId: "",
  priorityId: "",
  statusId: "",
  typeId: "",
  creationTime: "",
  isDataBank: false,
  creatorId: "",
};
export const workOrderHistoryFilterInitials = {
  title: "",
  creatorId: "",
  organizationGroupId: "",
  responsibleUserId: "",
  priorityId: "",
  typeId: "",
  statusId: "",
  creationTime: "",
};
export const workOrderDocumentFilterInitials = {
  fileName: "",
  fileCategoryId: "",
};
export interface IWorkOrderCategoryInitials {
  name: string;
  parentId: string;
  workOrderTypeId: string;
  organizationGroupId: string;
  productTypeCategories: IProductTypeCategories[];
}
export interface IProductTypeCategories {
  productTypeId: string;
  categoryId: string;
}

export const workOrderCategoryInitials: IWorkOrderCategoryInitials = {
  name: "",
  parentId: "",
  workOrderTypeId: "",
  organizationGroupId: "",
  productTypeCategories: [] as IProductTypeCategories[],
};

export const workOrderCategoryFilterInitials = {
  name: "",
  parentId: "",
  workOrderTypeId: "",
  organizationGroupId: "",
  mainCategoryId: "",
  categoryId: "",
  productTypeId: "",
  typeId: "",
};

export interface IWorkOrderTaskReminderInitials {
  taskTypeId: string;
  workPeriodId: number | null;
  customerId: string;
  organizationGroupListId: string[];
  organizationUserListId: any[];
  startDate: Date;
  endDate?: Date | null;
  subject: string;
  description: string;
  isActive: boolean;
  createAWorkOrder: boolean;
  isIndefinite: boolean;
}

export const workOrderTaskReminderInitials: IWorkOrderTaskReminderInitials = {
  taskTypeId: "",
  workPeriodId: null,
  customerId: "",
  organizationGroupListId: [],
  organizationUserListId: [],
  startDate: new Date(),
  endDate: null,
  subject: "",
  description: "",
  isActive: true,
  createAWorkOrder: false,
  isIndefinite: false,
};

export const workOrderTaskReminderFilterInitials = {
  taskTypeId: "",
  workPeriodId: "",
  customerId: "",
  organizationGroupId: "",
  responsibleUserId: "",
  startDate: "",
  endDate: "",
  subject: "",
  isActive: "",
  createAWorkOrder: "",
  remainingTimeId: 3,
};
